import React, { FC } from 'react';

import classNames from 'classnames';

import { DynamicComponent, BackToTop, Seo, NotFound } from '@/components';

import { buildCanonicalUrl } from '@/core/contentfulConfig';
import { TypeProductLandingPage } from '@/core/generated-types';

import useFeature from '@/hooks/useFeature';
import { FeatureFlagValues } from '@/core/featureFlags';

export const ProductLandingPageLayout: FC<TypeProductLandingPage> = (page) => {
  const {
    fields: {
      title,
      components,
      description,
      featureFlagName,
      enableInternalSticky,
    },
  } = page;

  const metadataFields = page.fields?.seoMetadata?.fields;

  const isFlagEnabled = useFeature(featureFlagName as keyof FeatureFlagValues);
  const isPageEnabled = isFlagEnabled ?? true;

  if (!isPageEnabled) {
    return <NotFound />;
  }

  return (
    <>
      <Seo
        title={metadataFields?.pageTitle}
        description={metadataFields?.pageDescription}
        nofollow={metadataFields?.noFollow}
        noindex={metadataFields?.noIndex}
        canonical={buildCanonicalUrl(page)}
      />
      <div
        className={classNames({
          'overflow-hidden': !enableInternalSticky,
        })}
      >
        {title && (
          <h1 className="container mx-auto mt-8 text-center text-d-h2 font-bold">
            {title}
          </h1>
        )}

        {description && <p className="container mx-auto">{description}</p>}

        <div>
          {components?.map((component) => (
            <DynamicComponent key={component.sys.id} component={component} />
          ))}
        </div>
      </div>
      <BackToTop />
    </>
  );
};
